export function QueryStatsIcon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.5668 14.975C16.9335 14.3917 17.1502 13.7167 17.1502 12.9833C17.1502 10.9083 15.4752 9.23333 13.4002 9.23333C11.3252 9.23333 9.65016 10.9083 9.65016 12.9833C9.65016 15.0583 11.3252 16.7333 13.3918 16.7333C14.1252 16.7333 14.8085 16.5167 15.3835 16.15L17.9835 18.75L19.1668 17.5667L16.5668 14.975ZM13.4002 15.0667C12.2502 15.0667 11.3168 14.1333 11.3168 12.9833C11.3168 11.8333 12.2502 10.9 13.4002 10.9C14.5502 10.9 15.4835 11.8333 15.4835 12.9833C15.4835 14.1333 14.5502 15.0667 13.4002 15.0667ZM13.1002 7.98333C12.4835 8 11.8918 8.13333 11.3502 8.35833L10.8918 7.66667L7.72516 12.8167L5.21683 9.88333L2.19183 14.725L0.833496 13.75L5.00016 7.08333L7.50016 10L10.8335 4.58333L13.1002 7.98333ZM15.2585 8.4C14.7252 8.16667 14.1502 8.025 13.5502 7.99167L17.8168 1.25L19.1668 2.23333L15.2585 8.4Z"
        fill="currentColor"
      />
    </svg>
  )
}
